import * as React from 'react';
import {withGlobalize, WithGlobalizeProps} from 'react-native-globalize';
import {code} from 'currency-codes';
import TextInput from './AVTextInput';
import Util from 'src/Util';
import {StyleProp, ViewStyle} from 'react-native';
type CurrencyInputProps = WithGlobalizeProps & {
  value: number;
  currency: string;
  onUpdate: (value: number | null | undefined) => void;
  style: StyleProp<ViewStyle>;
  label: string;
  accessibilityLabel: string;
};

class CurrencyInput extends React.PureComponent<CurrencyInputProps> {
  divisor: number;

  constructor(props: CurrencyInputProps) {
    super(props);
    const decimalPlaces = code(props.currency).digits;
    this.divisor = Math.pow(10, decimalPlaces);
    this.formatNumberValue = this.formatNumberValue.bind(this);
    this.parseStringValue = this.parseStringValue.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
  }

  formatNumberValue(value: number): string {
    let returnValue = '';

    if (value) {
      returnValue = Util.formatCurrency(this.props, value, this.props.currency);
    }

    return returnValue;
  }

  parseStringValue(text: string): number | null | undefined {
    const digitsOnly = text.match(/\d+/g);
    return digitsOnly
      ? parseInt(digitsOnly.join(''), 10) / this.divisor
      : undefined;
  }

  onUpdate(text: string) {
    const {onUpdate} = this.props;

    if (onUpdate) {
      const parsedValue = this.parseStringValue(text);
      onUpdate(parsedValue);
    }
  }

  render() {
    const {value, style, label, accessibilityLabel} = this.props;
    return (
      <TextInput
        style={style}
        label={label}
        accessibilityLabel={accessibilityLabel}
        value={this.formatNumberValue(value)}
        keyboardType="number-pad"
        onChangeText={this.onUpdate}
      />
    );
  }
}

export default withGlobalize(CurrencyInput);
